import { Alert } from '@cmsgov/design-system'
import { Button } from 'components/Button/Button'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export interface EMSNSearchAlertProps {
  claimNumberError: string
}

export const EMSNSearchAlert: FC<EMSNSearchAlertProps> = ({ claimNumberError }) => {
  const { t } = useTranslation('eMSNPage')

  return (
    <Alert hideIcon variation='error' heading={t('emsn-search.error-heading')}>
      <ul>
        <li>
          <Button href='#claimNumber'>
            {t('emsn-search.claim-number.label')}
          </Button>
          <span>{`: ${claimNumberError}`}</span>
        </li>
      </ul>
    </Alert>
  )
}
